<template>
  <div class="mune_box">
    <div class="tabList">
      <div
        v-for="item in topNavData"
        :key="item.menuId || item.name"
        :class="['reference', { active: item.menuId == activeCategory.menuId }]"
        @click="tabFn(item)"
      >
        <img
          v-show="item.meta.icon != '#'"
          class="img"
          :src="getMenuIcon(item.meta.icon)"
          alt=""
        >
        {{ proxy.$t('menu.' + item.name) }} <i class="el-icon-arrow-down" />
      </div>
      <el-popover
        v-model:visible="popoverVisible"
        placement="bottom-start"
        :offset="-3"
        :show-arrow="false"
        popper-class="popper-menu_is"
      >
        <div class="mune_item_box">
          <div class="title_box">
            <div
              v-for="item in visibleMenuList"
              :key="item.tabType"
              class="title_item"
            >
              <div class="item_title">
                <div class="center">
                  {{ proxy.$t('menu.' + item.titleKey) }}
                </div>
              </div>
              <div
                class="menu_box"
                :class="{ 'menu_box--double': item.tabType === '1' }"
              >
                <div
                  v-for="items in item.list"
                  :key="items.menuId || items.name"
                  class="menu-entry"
                  :class="{ 'menu-entry--wide': shortcutColumns[items.name] }"
                >
                  <div
                    :class="['menu_item', { active: items.menuId == activeCategory.menuId }]"
                    @click="tabFn(items)"
                  >
                    <img
                      class="img"
                      :src="getMenuIcon(items.meta.icon)"
                      alt=""
                    >
                    <div
                      class="menuTitle"
                      :title="proxy.$t('menu.' + items.name)"
                    >
                      {{ proxy.$t('menu.' + items.name) }}
                    </div>
                    <el-tooltip
                      v-if="!items.isMock"
                      class="box-item"
                      effect="dark"
                      :content="proxy.$t('menu.topNavTip')"
                      placement="top"
                      :disabled="onPositionActiveFn(items) || onActiveshow()"
                    >
                      <svg
                        :class="['position', 'position-icon', { actives: onPositionActiveFn(items) }, { activeshow: onActiveshow() }]"
                        viewBox="0 0 1024 1024"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        @click.stop="onPosition(items)"
                      >
                        <path
                          d="M334.1824 616.0896l73.728 73.728c-72.6016 61.44-178.6368 156.928-200.5504 174.08C151.7056 907.5712 102.4 921.6 102.4 921.6s14.0288-49.2544 57.7024-104.96c17.152-21.9136 112.64-127.8976 174.08-200.5504zM905.9328 315.392l-197.2736-197.3248a53.4016 53.4016 0 1 0-75.6736 75.6224l15.7184 15.7184-288.1536 203.5712L296.7552 349.184a53.4016 53.4016 0 1 0-75.6224 75.6224l378.0096 377.9584a53.4016 53.4016 0 1 0 75.6224-75.6224l-63.6928-63.6928 203.52-288.256 15.7184 15.7184a53.4016 53.4016 0 1 0 75.6224-75.5712z"
                          fill="currentColor"
                        />
                      </svg>
                    </el-tooltip>
                  </div>
                  <div
                    v-if="shortcutColumns[items.name]"
                    class="second-menu-shortcuts"
                    :style="{ '--shortcut-columns': shortcutColumns[items.name] }"
                  >
                    <div
                      v-for="child in getSecondMenuShortcuts(items)"
                      :key="child.menuId || child.name"
                      class="second-menu-shortcut"
                      @click.stop="shortcutFn(items, child)"
                    >
                      {{ child.isMock ? proxy.$t('menu.' + child.name) : child.meta?.title }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template #reference>
          <div :class="['reference', { active: activeFn() }]">
            <svg-icon
              class-name="app-icon"
              icon-class="app"
            />
            {{ activeFn() ? proxy.$t('menu.' + activeCategory.name) : proxy.$t('menu.Business') }}
            <i>
              <el-icon class="el-icon-arrow-down"><ArrowDown /></el-icon>
            </i>
          </div>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance, onBeforeUnmount, onMounted, ref, type ComponentInternalInstance } from 'vue';
import { useRouter } from 'vue-router';
import { usePermissionStore } from '../../store/modules/permission.ts';

const { proxy } = getCurrentInstance() as ComponentInternalInstance;
const menuIcons = import.meta.glob('../../assets/images/mune/*.png', { eager: true, import: 'default' });
const getMenuIcon = (icon: string) => menuIcons[`../../assets/images/mune/${icon}.png`];
//
// 展示在顶部的类别    品牌默认固定在首页
const topNavData = ref([]);

// true：展示布局演示菜单；false：仅展示当前账号真实菜单。
const useMockMenu = false;
const shortcutColumns: Record<string, number> = {
  StoreOperations: 3,
  DemoPlatformBusiness: 2,
};
const mockMenuIcons = Object.keys(menuIcons).map((path) => path.split('/').pop()!.replace('.png', ''));
let lastMockIcon = '';
const createMockMenu = (name: string, children: string[] = []) => {
  const availableIcons = mockMenuIcons.filter((icon) => icon !== lastMockIcon);
  const icon = availableIcons[Math.floor(Math.random() * availableIcons.length)];
  lastMockIcon = icon;
  return {
    menuId: `demo-${name}`,
    name,
    isMock: true,
    meta: { icon },
    children: children.map((child) => ({ menuId: `demo-${child}`, name: child, isMock: true })),
  };
};
const mockMenuGroups = [
  [
    createMockMenu('StoreOperations', ['DemoMiniOrder', 'CommonCenter', 'ProductManage', 'OrderManage', 'BizManag', 'DemoMore']),
    createMockMenu('DemoPlatformBusiness', ['DemoDeliveryCenter', 'DemoGroupBuying']),
    ...['DemoRetailMall', 'DemoQueue', 'DemoDelivery', 'DemoReservation', 'DemoMealScreen', 'ProjectDeduction'].map((name) => createMockMenu(name)),
  ],
  ['Membership', 'DemoMarketingAutomation', 'DemoSocialCRM', 'DemoMarketing', 'DemoCardManagement', 'DemoMemberData'].map((name) => createMockMenu(name)),
  ['DemoSupplyChain', 'DemoSmartWarning', 'DemoBrandControl'].map((name) => createMockMenu(name)),
  ['DemoFinanceAccounting', 'DemoInvoice', 'DemoFinanceVoucher'].map((name) => createMockMenu(name)),
  [createMockMenu('OperateReport')],
];
const menuList = ref([
  {
    titleKey: 'SmartStore',
    list: [],
    tabType: '1',
  },
  {
    titleKey: 'AllPhenomena',
    list: [],
    tabType: '2',
  },
  {
    titleKey: 'DataAnalysis',
    list: [],
    tabType: '3',
  },
]);
const visibleMenuList = computed(() => {
  if (useMockMenu) {
    return ['SmartStore', 'AllPhenomena', 'DemoSupplyChain', 'DemoFinanceManagement', 'DataAnalysis'].map((titleKey, index) => ({
      titleKey,
      tabType: String(index + 1),
      list: mockMenuGroups[index],
    }));
  }
  return menuList.value.filter((item) => item.list.length > 0);
});

// 顶部栏初始数
const visibleNumber = ref<number>(-1);
const permissionStore = usePermissionStore();
const router = useRouter();
const popoverVisible = ref(false);
onMounted(() => {
  const menuTypeData = permissionStore.getSidebarRoutesData().filter((v) => {
    return v.menuType == 'S' && !v.hidden;
  });
  let cachedMenus = [];
  try {
    const storedMenus = JSON.parse(localStorage.getItem('CommonMenuList') || '[]');
    cachedMenus = Array.isArray(storedMenus) ? storedMenus : [];
  } catch {
    cachedMenus = [];
  }
  // 缓存只恢复收藏顺序，菜单内容及访问范围以当前账号的授权菜单为准。
  const authorizedMenus = new Map(menuTypeData.map((item) => [String(item.menuId), item]));
  topNavData.value = cachedMenus
    .map((item) => authorizedMenus.get(String(item?.menuId)))
    .filter(Boolean);
  if (topNavData.value.length == 0 && authorizedMenus.has('1')) {
    topNavData.value.push(authorizedMenus.get('1'));
  }
  localStorage.setItem('CommonMenuList', JSON.stringify(topNavData.value));
  // 1. 把 menuList 转成 Map，方便按 tabType 查找
  const tabTypeMap = new Map(menuList.value.map((item) => [item.tabType, item]));
  // 2. 遍历数据源，按 tabType 分组
  menuTypeData.forEach((item) => {
    const target = tabTypeMap.get(item.tagType);

    if (target) {
      target.list.push(item); // 把当前项放进对应的 list 里
    }
  });
});
// 选择类别
const tabFn = (item) => {
  if (item.isMock) return;
  permissionStore.setActiveCategory(item);
  popoverVisible.value = false;
  permissionStore.setSidebarRouters(1);
};
const getSecondMenuShortcuts = (item) => {
  return (item.children || []).filter((child) => !child.hidden && child.menuType !== 'F');
};
const normalizeMenuPath = (parentPath = '', path = '') => {
  const currentPath = path.startsWith('/') ? path : `/${path}`;
  let fullParentPath = '';
  if (parentPath) {
    fullParentPath = parentPath.startsWith('/') ? parentPath : `/${parentPath}`;
  }
  if (fullParentPath && currentPath.startsWith(`${fullParentPath}/`)) {
    return currentPath;
  }
  return `${fullParentPath}${currentPath}`.replace(/\/+/g, '/');
};
const findFirstMenuWithPath = (menuNodes = [], parentPath = '') => {
  for (const node of menuNodes) {
    if (node.hidden || node.menuType === 'F') {
      continue;
    }

    const currentPath = normalizeMenuPath(parentPath, node.path || '');
    if (node.menuType === 'C') {
      return currentPath;
    }
    if (node.children?.length) {
      const childPath = findFirstMenuWithPath(node.children, currentPath);
      if (childPath) {
        return childPath;
      }
    }
  }
  return '';
};
const shortcutFn = (parent, child) => {
  if (parent.isMock || child.isMock) return;
  permissionStore.setActiveCategory(parent);
  permissionStore.setSidebarRouters(2);
  popoverVisible.value = false;
  const path = findFirstMenuWithPath([child], parent.path);
  if (path) {
    router.push(path);
  }
};
// 默认激活类别
const activeCategory = computed(() => {
  return permissionStore.getActiveCategory();
});
// 添加  删除固定
const onPosition = (item) => {
  if (item.isMock) return;
  if (
    topNavData.value.filter((v) => {
      return v.menuId == item.menuId;
    }).length == 0
  ) {
    // 不存在  添加
    topNavData.value.push(item);
  } else {
    // 存在删除
    topNavData.value = topNavData.value.filter((v) => {
      return v.menuId != item.menuId;
    });
  }
  localStorage.setItem('CommonMenuList', JSON.stringify(topNavData.value));
};
//
const onActiveshow = () => {
  return topNavData.value.length > 3;
};
// 是否固定
const onPositionActiveFn = (item) => {
  return (
    topNavData.value.filter((v) => {
      return v.menuId == item.menuId;
    }).length > 0
  );
};
// 默认列表固定
const activeFn = () => {
  return (
    topNavData.value.filter((v) => {
      return v.menuId == activeCategory.value.menuId;
    }).length == 0 && activeCategory.value.menuId
  );
};

const setVisibleNumber = () => {
  const width = document.body.getBoundingClientRect().width / 3;
  visibleNumber.value = parseInt(String(width / 85));
};

//
onBeforeUnmount(() => {
  window.removeEventListener('resize', setVisibleNumber);
});

// onMounted(() => {
//   setVisibleNumber();
// });
</script>

<style lang="scss" scoped>
.img {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.mune_box {
  --top-nav-active-bg: #f0f3f9;

  display: flex;
  height: 64px;
  font-family: var(--el-font-family);

  .tabList {
    display: flex;
    align-items: flex-end;
    gap: 4px;
  }
  .reference {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 0 16px;
    height: 60px;
    line-height: 22px;
    border-radius: 6px 6px 0 0;
    color: var(--el-text-color-regular);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    transition: color var(--el-transition-duration-fast), background-color var(--el-transition-duration-fast);

    &:hover,
    &.active {
      color: var(--el-color-primary);
    }

    &.active {
      z-index: 1;
      background: var(--top-nav-active-bg);
      font-weight: 700;

      // 两侧底部向外延伸，与下方内容形成反向圆角衔接。
      &::before,
      &::after {
        position: absolute;
        bottom: 0;
        width: 10px;
        height: 10px;
        content: '';
        pointer-events: none;
      }

      &::before {
        left: -10px;
        background: radial-gradient(circle at left top, transparent 9.5px, var(--top-nav-active-bg) 10px);
      }

      &::after {
        right: -10px;
        background: radial-gradient(circle at right top, transparent 9.5px, var(--top-nav-active-bg) 10px);
      }
    }

    :deep(.app-icon) {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
    }

    > i {
      display: inline-flex;
      align-items: center;
    }

    .el-icon-arrow-down {
      font-size: 12px;
      transition: transform var(--el-transition-duration-fast);
    }
    &:hover .el-icon-arrow-down {
      transform: rotate(180deg);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .reference,
    .el-icon-arrow-down {
      transition: none;
    }
  }
}

html.dark .mune_box {
  --top-nav-active-bg: var(--el-fill-color-light);
}

.mune_item_box {
  padding: 0 40px 16px 12px;
  overflow-x: auto;
}

.title_box {
  display: flex;
  width: max-content;
  font-size: 14px;

  gap: 32px;
  align-items: flex-start;
  .title_item {
    flex: none;

    .item_title {
      line-height: 30px;
      color: #8d8d8d;

      padding: 0 10px;

      .center {
        border-bottom: #e6e6e6 solid 1px;
      }
    }

    .menu_box {
      display: grid;
      grid-template-columns: auto;
      gap: 10px 8px;
      padding-top: 10px;
      align-items: start;
      &--double {
        grid-template-columns: repeat(2, 154px);
      }
      .menu-entry {
        min-width: 0;
      }
      .menu-entry--wide {
        grid-column: 1 / -1;
        > .menu_item {
          width: calc((100% - 8px) / 2);
        }
      }
      .menu_item {
        box-sizing: border-box;
        width: 100%;
        min-height: 34px;
        color: #333;
        line-height: 34px;
        padding: 0 10px;
        padding-inline-end: 20px;
        position: relative;
        border-radius: 4px;
        cursor: pointer;
        font-weight: 500;

        .menuTitle {
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .img {
          flex-shrink: 0;
          align-self: center;
          width: 24px;
          height: 24px;
          position: static;
          margin-right: 5px;
        }

        &:hover {
          background: #f5f5f5;
          .position {
            opacity: 1;
          }
        }
        .position {
          position: absolute;
          inset-inline-end: 3px;
          opacity: 0;
          margin-top: 10px;
          margin-inline-start: 3px;
          color: #999;
          &.actives {
            color: var(--color-1) !important;
            opacity: 1 !important;
          }
          &.activeshow {
            opacity: 0;
          }
        }
        .position-icon {
          width: 14px;
          height: 14px;
        }
      }
      .second-menu-shortcuts {
        display: grid;
        grid-template-columns: repeat(var(--shortcut-columns), minmax(0, 1fr));
        gap: 8px;
        width: 100%;
        margin-top: 8px;
        margin-bottom: 6px;
      }
      .second-menu-shortcut {
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #333;
        background: #f5f7fa;
        border-radius: 4px;
        cursor: pointer;
        &:hover {
          background: var(--bg-1);
          color: var(--color-1);
        }
      }

      .active {
        background: var(--bg-1) !important;
        color: var(--color-1) !important;
        font-weight: 700;
      }
    }
  }
}

.topmenu-container.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 50px !important;
  line-height: 50px !important;
  color: #999093 !important;
  padding: 0 5px !important;
  margin: 0 10px !important;
}

.topmenu-container.el-menu--horizontal > .el-menu-item.is-active,
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #{'var(--theme)'} !important;
  color: #303133;
}

/* submenu item */
.topmenu-container.el-menu--horizontal > .el-submenu .el-submenu__title {
  float: left;
  height: 50px !important;
  line-height: 50px !important;
  color: #999093 !important;
  padding: 0 5px !important;
  margin: 0 10px !important;
}

.menu_item {
  display: flex;
  // justify-content: space-between;
}

.menutitle {
  width: 100px;
}
</style>

<style lang="scss">
.el-popover.el-popper.popper-menu_is {
  width: auto !important;
  max-width: calc(100vw - 24px);
  border-radius: 8px;
  box-shadow: var(--el-box-shadow);
}
</style>
